import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { usePageOpenActivityMutation } from '../features/activity/api/activityApi';
import { RootState } from '../store';

export const useTrackPageActivity = () => {
    const { isAuthenticated } = useAuth0();
    const location = useLocation();
    const { isLoggedIn } = useSelector((state: RootState) => state.auth);
    const [pageOpenActivity] = usePageOpenActivityMutation();

    useEffect(() => {
        if (isAuthenticated && isLoggedIn) {
            pageOpenActivity({ url: window.location.href });
        }
    }, [location, isAuthenticated, pageOpenActivity, isLoggedIn]);
};
